import { render, staticRenderFns } from "./TaskMonitoringTable.vue?vue&type=template&id=0b5c329a&scoped=true"
import script from "./TaskMonitoringTable.vue?vue&type=script&lang=js"
export * from "./TaskMonitoringTable.vue?vue&type=script&lang=js"
import style0 from "./TaskMonitoringTable.vue?vue&type=style&index=0&id=0b5c329a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c329a",
  null
  
)

export default component.exports